import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^\+?[0-9]{7,15}$/; 
    return phoneRegex.test(phone);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setResponseMsg({ type: "", text: "" });

  //   if (!validatePhone(formData.phone)) {
  //     setResponseMsg({
  //       type: "error",
  //       text: "Please enter a valid phone number (7–15 digits, optionally starting with +).",
  //     });
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const res = await axios.post("https://vantara.datacubeglobal.com/api/customer-enquiry", {
  //       name: formData.name,
  //       email: formData.email,
  //       phone: formData.phone,
  //       message: formData.message,
  //     });

  //     if (res.data.status === "success") {
  //       setResponseMsg({
  //         type: "success",
  //         text: "Your message has been sent successfully!",
  //       });
  //       setFormData({ name: "", email: "", phone: "", message: "" });
  //     } else {
  //       setResponseMsg({
  //         type: "error",
  //         text: res.data.message || "Failed to send message. Please try again.",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error submitting enquiry:", error);
  //     setResponseMsg({
  //       type: "error",
  //       text:
  //         error.response?.data?.message ||
  //         "Something went wrong. Please try again.",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setResponseMsg({ type: "", text: "" });

  if (!validatePhone(formData.phone)) {
    setResponseMsg({
      type: "error",
      text: "Please enter a valid phone number (7–15 digits, optionally starting with +).",
    });
    return;
  }

  setLoading(true);

  try {
    const res = await axios.post("https://vantara.datacubeglobal.com/api/customer-enquiry", {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
    });

    if (res.data.status === "success") {
      setResponseMsg({
        type: "success",
        text: "Your message has been sent successfully!",
      });
      setFormData({ name: "", email: "", phone: "", message: "" });


      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      setResponseMsg({
        type: "error",
        text: res.data.message || "Failed to send message. Please try again.",
      });
    }
  } catch (error) {
    console.error("Error submitting enquiry:", error);
    setResponseMsg({
      type: "error",
      text:
        error.response?.data?.message ||
        "Something went wrong. Please try again.",
    });
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container py-5">
   
      <div className="row g-4 mb-5">
        <div className="col-lg-6">
          <div className="ratio ratio-16x9 rounded shadow-sm">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3922.8758392113973!2d76.01401807368345!3d11.52262928869267!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba5be4f76f91f09%3A0x2d46f0c7a986a989!2sVythiri%2C%20Wayanad%2C%20Kerala%20673576!5e0!3m2!1sen!2sin!4v1730490000000!5m2!1sen!2sin"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              title="Google Map - Vythiri Wayanad"
            ></iframe>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="p-4 border rounded shadow-sm h-100">
            <h4 className="mb-4">Information</h4>
            <p><strong>Phone:</strong> +91 98765 43210</p>
            <p><strong>Email:</strong> info@vantara.com</p>
            <p>
              <strong>Address:</strong><br />
              Vythiri, Wayanad, Kerala, India
            </p>
            <p>
              <strong>Open Time:</strong><br />
              Mon – Sat: 9:00am – 6:00pm IST <br />
              Sunday: Closed
            </p>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <div className="row justify-content-center">
        <div className="col-lg-8 mx-auto">
          <div className="text-center mb-5">
            <h2 className="display-6 fw-bold text-dark">Get In Touch</h2>
            <p className="text-muted mt-2">
              Use the form below to get in touch with the sales team
            </p>
          </div>

          <div className="p-4 border rounded shadow-sm">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control border border-secondary"
                    placeholder="Your Name*"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control border border-secondary"
                    placeholder="Your Email*"
                    required
                  />
                </div>
                <div className="col-md-12">
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-control border border-secondary"
                    placeholder="Your Phone*"
                    required
                  />
                </div>
                <div className="col-12">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control border border-secondary"
                    rows="5"
                    placeholder="Your Message*"
                    required
                  ></textarea>
                </div>
                <div className="col-12 text-center">
                  <button
                    type="submit"
                    className="btn px-5 py-3 rounded-pill shadow-sm"
                    style={{ background: "#7c0046", color: "#fff" }}
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </div>

                {responseMsg.text && (
                  <div
                    className={`text-center mt-3 fw-semibold ${
                      responseMsg.type === "success"
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {responseMsg.text}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
